import { ETelemetryMessageType } from '../enums/ETelemetryPacketType'
import { TELEMETRY_PACKET_DELIMITER } from '../getStandard'
import { parsePacketMessageByType } from './parsePacketMessageByType'
import { IChartPackets } from '../transformLogToChartPacket'
import { parseTelemetryPacket } from './parseTelemetryPacket'

export function transformTelemetryLogToChartPackets(content: string): IChartPackets {
    const packets: IChartPackets = {
        dpr: [],
        tankPressures: [],
        ticks: [],
        modes: [],
        magnitudes: {
            dpr: 'bar',
            lox: 'bar',
            fuel: 'bar',
            battery: 'V',
        },
    }

    // * PARSE
    // discard the first packet, as it may be incomplete
    let [, ...telemetryPackets] = content.split(TELEMETRY_PACKET_DELIMITER).filter((f) => f)

    telemetryPackets = telemetryPackets.filter((packet) => !hasSDMountError(packet))

    const parsedPackets = telemetryPackets.map((packet) => parseTelemetryPacket(packet))

    for (const packet of parsedPackets) {
        const type = packet.type
        const timestamp = parseInt(packet.timestamp)

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const data: any = parsePacketMessageByType(type, packet.message)

        if (type === ETelemetryMessageType.tankPressures) {
            packets.dpr.push({
                timestamp,
                dpr: data.DPR,
            })
            packets.tankPressures.push({
                timestamp,
                fuel: data.fuel,
                lox: data.LOX,
            })
        }

        // TODO add other types
    }

    return packets
}

function hasSDMountError(content: string) {
    // ERROR: Failed to mount SD card
    return content.includes(`Failed to\nmount SD card`)
}
